import React from 'react';
import { IconProps } from '@msc-b2c/interfaces/types';
import classNames from 'classnames';
import { handleKeyDown } from '@msc-b2c/shared-utils/keyboardUtils';

export const Icon = ({
  icon,
  ariaHidden = false,
  ariaLabel,
  onClick,
  styleOption,
  tooltipTitle,
  color,
}: IconProps) => {
  const handleKeyDownWrapper = (event: React.KeyboardEvent) => {
    handleKeyDown(event, onClick as (...args: any[]) => void);
  };

  return (
    icon !== 'no-icon' && (
      <i
        aria-hidden={ariaHidden}
        aria-label={ariaHidden ? undefined : ariaLabel}
        className={classNames(
          'icon',
          { [`icon-${icon}`]: icon },
          { 'clickable-icon': icon && onClick },
          styleOption
        )}
        onClick={onClick}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : -1}
        onKeyDown={onClick ? handleKeyDownWrapper : undefined}
        data-testid={`icon - ${ariaLabel || 'default'}`}
        title={tooltipTitle ?? ''}
        style={{ color }}
      ></i>
    )
  );
};
